"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
// import { ILimberLink } from '../../interfaces';
var LimberEditButtonComponent = (function () {
    function LimberEditButtonComponent() {
        var _this = this;
        this.editClicked = function (event) {
            if (_this.openEditor !== null) {
                _this.openEditor();
            }
            event.preventDefault();
        };
    }
    LimberEditButtonComponent.prototype.ngOnInit = function () {
    };
    return LimberEditButtonComponent;
}());
LimberEditButtonComponent.decorators = [
    { type: core_1.Component, args: [{
                // moduleId: module.id,
                selector: "limber-edit-button",
                template: "\n    <a href=\"#\" (click)=\"editClicked($event)\"><font-awesome [faIcon]=\"'wrench'\"></font-awesome></a>\n  ",
                styles: ["\n    :host { display: inline-block; position: absolute; padding: 3px; background-color: skyblue; color: white; border-radius: 5px; border: 1px solid white; box-shadow: 1px 1px 5px black; }\n\n    :host:hover { background-color: deepskyblue; }\n  "]
            },] },
];
/** @nocollapse */
LimberEditButtonComponent.ctorParameters = function () { return []; };
LimberEditButtonComponent.propDecorators = {
    'openEditor': [{ type: core_1.Input },],
};
exports.LimberEditButtonComponent = LimberEditButtonComponent;
//# sourceMappingURL=limber-edit-button.component.js.map